<script>
export default {
    name: "PharmacyIssueReport",

    data() {

        return {
            filter: {
                from: this.$moment().format(`YYYY-MM-DD`),
                to: this.$moment().format(`YYYY-MM-DD`),
                storeId: 0,
                itemId: 0,
                itemName: ``,
            },
            stores: [],
            issues: [],
            itemIssueHistory: [],
            viewItemHistory: false,
            item: {},
            searchItem: false,
            items: [],
        };
    },

    mounted() {

        this.$root.loading = true;
        Promise.all([ this.fetchIssueReport(),this.fetchStores(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {
        fetchStores() {

return this.$http.get(`Shared/GetStoreLocations`).then(({ data }) => {
    this.stores = data;
}).catch(() => {});
},
        fetchSearchedItems() {
            if(!this.filter.itemName) return Promise.reject();

            let url = `Shared/GetSearchItems`;
                url += `?SearchItems=${this.filter.itemName}`;
            this.$root.loading = true;
            return this.$http.get(url).then(({ data}) => {
                this.items = data;
                this.$root.loading = false;
                this.searchItem = true;
            }).catch(() => { this.$root.loading = false; });
        },

        fetchIssueReport() {
            let url = `Pharmacy/GetDrugsIssuedReport`;
                url += `?FromDate=${this.filter.from}`;
                url += `&ToDate=${this.filter.to}`;
                url += `&StoreId=${this.filter.storeId}`;
                url += this.filter.itemId ? `&ItemId=${this.filter.itemId}` : ``;

            return this.$http.get(url).then(({ data }) => {
                this.issues = data;
            }).catch(() => {});
        },

        fetchItemIssueHistory(item) {
            this.$root.loading = true;
            let url = `Pharmacy/GetPatientDrugIssueReport`;
                url += `?FromDate=${this.filter.from}`;
                url += `&ToDate=${this.filter.to}`;
                url += `&ItemId=${item.serviceId}`;

            return this.$http.get(url).then(({ data }) => {
                this.item = item;
                this.itemIssueHistory = data;
                this.$root.loading = false;
                this.viewItemHistory = true;
            }).catch(() => { this.$root.loading = false; });
        },
    },

    components: {
        'item-issue-history': () => import('./modals/ItemIssueHistory.vue')
    },
}
</script>
<template>
<tail-base-layout>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
            <h5 class="font-bold text-sm">Report: Pharmacy Drug Issue</h5>
        </template>
        <template v-slot:card-body>
          <div class="flex flex-wrap">
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.from" 
                    id="grid-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.to" 
                    id="grid-to" class="input-control input-sm text-xs">
              </div>
              <div class="w-1/4 p-tiny">
                    <label for="grid-store-from" class="label-control">Store:</label> <tail-select>
                    <template v-slot:field>
                        <select id="grid-store-from" 
                              v-model.trim="filter.storeId"
                            class="input-control input-sm text-xs">
                            <option :value="0">Select store</option>
                            <option v-for="store in stores" 
                                :key="store.id" :value="store.id">{{ store.name }}</option>
                        </select>
                    </template>
                </tail-select>
               
            </div>   <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-item-name" class="label-control">Item:</label>
                  <input type="text" v-model.trim="filter.itemName" 
                    @keydown.enter="fetchSearchedItems"
                    id="grid-item-name" class="input-control input-sm text-xs">
                <tail-drug-select 
                    :showModal="searchItem"
                    :items="items"
                    @closeModal="searchItem=false"
                    @itemSelected="(item) => {
                        filter.itemName = item.itemName;
                        filter.itemId = item.itemID;
                        searchItem = false;
                    }"
                />
              </div>
              <div class="md:w-2/12 sm:w-full p-tiny mt-3">
                  <button 
                    @click.prevent="() => {
                        $root.loading = true;
                        fetchIssueReport().then(() => {
                            $root.loading = false;
                        });
                    }"
                    class="btn-sm btn-info text-xs rounded mr-2">
                      <i class="fa fa-search"></i> Filter
                  </button>
                  <button
                    @click.prevent="() => {
                        filter.itemId = 0;
                        filter.itemName = ``;
                    }"
                    class="btn-sm btn-danger text-xs rounded">
                      <i class="fa fa-times"></i> Clear
                  </button>
              </div>
              <item-issue-history 
                :itemIssueHistory="itemIssueHistory"
                :showModal="viewItemHistory"
                :item="item"
                @closeModal="() => {
                    viewItemHistory = false;
                    itemIssueHistory = [];
                    item = {};
                }"
              />
          </div>
          <div class="w-full overflow-auto">
              <table class="table table-hover">
                  <thead class="bg-indigo-400 text-xs text-white">
                        <tr class="w-full flex">
                            <th class="p-tiny flex-1">Id</th>
                            <th class="p-tiny flex-1">Item</th>
                            <th class="p-tiny flex-1">Qty</th>
                            <th class="p-tiny flex-1">Action</th>
                        </tr>
                  </thead>
                  <tbody class="text-xs bg-gray-100 flex flex-col items-center overflow-auto" 
                    style="max-height:65vh;">
                      <tr class="w-full flex" v-for="(issue,idx) in issues" :key="idx">
                          <td class="p-tiny flex-1">{{ issue.serviceId }}</td>
                          <td class="p-tiny flex-1">{{ issue.service }}</td>
                          <td class="p-tiny flex-1">{{ issue.issued }}</td>
                          <td class="p-tiny flex-1">
                              <button
                                @click.prevent="fetchItemIssueHistory(issue)"
                                class="btn-sm btn-info text-xs rounded">
                                    <i class="fa fa-eye"></i> View</button>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>